import React, { useEffect, useRef, useState } from "react"
import "./_reviveAdds.scss"

export const ReviveAd = ({ zoneId }) => {
  const reviveId = "4d3dce4db16ff385dd1c5dd5ade84a88"
  const adContainerRef = useRef(null)
  const [reviveAsync, setReviveAsync] = useState()

  useEffect(() => {
    const adContainer = adContainerRef.current

    if (adContainer) {
      // Create the ins element
      const ins = document.createElement("ins")
      ins.setAttribute("data-revive-zoneid", zoneId)
      ins.setAttribute("data-revive-id", reviveId)

      // Create the script element
      const script = document.createElement("script")
      script.async = true
      script.src = "//rv.sinarmasland.com/www/delivery/asyncjs.php"

      // Append elements
      adContainer.appendChild(ins)
      adContainer.appendChild(script)

      // Cleanup function
      return () => {
        adContainer.innerHTML = ""
      }
    }
  }, [zoneId])

  useEffect(() => {
    setReviveAsync(window.reviveAsync)
  }, []);

  useEffect(() => {
    if (!reviveAsync) {
      return;
    }

    console.log("refreshing ads");
    reviveAsync[reviveId].refresh();
  }, [reviveAsync]);

  return <div ref={adContainerRef} className="revive-container"></div>
}
